// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../intl/Intl_Utils.bs.js";
import * as Route_Paths$DvmAdminFrontendFr from "../../../../route/Route_Paths.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../../../theme/Theme_Colors.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../../common/App_Typography.bs.js";
import * as App_Types_Status$DvmAdminFrontendFr from "../../../../common/types/App_Types_Status.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../../context/user/User_Types_Utils.bs.js";
import * as App_Styles_Status$DvmAdminFrontendFr from "../../../../common/styles/App_Styles_Status.bs.js";
import * as Order_Detail_Styles$DvmAdminFrontendFr from "../Order_Detail_Styles.bs.js";
import * as Messages_Flash_Search$DvmAdminFrontendFr from "../../../../intl/messages/flash/Messages_Flash_Search.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";

function isPSERWithEmptyStatus(bonus) {
  if (Belt_Option.getWithDefault(bonus.requestType, "") === "PSER") {
    return Belt_Option.mapWithDefault(bonus.resultActionStatus, true, (function (x) {
                  if (x === /* MISSINGSTATUS */11) {
                    return true;
                  } else {
                    return x === /* EMPTYSTATUS */10;
                  }
                }));
  } else {
    return false;
  }
}

function getAmountText(bonus, archived, intl) {
  if (isPSERWithEmptyStatus(bonus)) {
    return Belt_Option.mapWithDefault(bonus.resultBonus, "-", (function (x) {
                  if (x === 0.0) {
                    return "-";
                  } else {
                    return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                  }
                }));
  }
  var match = bonus.resultBonus;
  var match$1 = bonus.resultActionStatus;
  if (match !== undefined && !(match$1 !== undefined && match$1 === /* BLOCKED */0 && archived === true && match === 0.0)) {
    return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, match);
  } else {
    return "-";
  }
}

function Order_Detail_Bonus_Box_Shared$Status(Props) {
  var bonus = Props.bonus;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var selectedRole = match[0].selectedRole;
  return React.createElement(Core.Grid, {
              alignItems: "flex-start",
              children: null,
              className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
              container: true,
              item: true
            }, React.createElement(Core.Grid, {
                  alignItems: "center",
                  children: null,
                  container: true,
                  item: true,
                  spacing: 1
                }, React.createElement(Core.Grid, {
                      children: React.createElement(Core.Box, {
                            className: App_Styles_Status$DvmAdminFrontendFr.oval,
                            bgcolor: App_Styles_Status$DvmAdminFrontendFr.stateColors(Belt_Option.getWithDefault(bonus.resultActionStatus, /* EMPTYSTATUS */10))
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: intl.formatMessage(App_Types_Status$DvmAdminFrontendFr.toMessage(Belt_Option.getWithDefault(bonus.resultActionStatus, /* EMPTYSTATUS */10))),
                      item: true
                    })), Belt_Option.mapWithDefault(bonus.perfApproval, null, (function (validationDetail) {
                    return Belt_Option.mapWithDefault(validationDetail.approved, null, (function (approved) {
                                  var match = validationDetail.date;
                                  var match$1 = validationDetail.approver;
                                  if (match !== undefined && match$1 !== undefined) {
                                    return React.createElement(Core.Grid, {
                                                children: null,
                                                container: true,
                                                direction: "column",
                                                item: true
                                              }, React.createElement(Core.Grid, {
                                                    children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                                          style: {
                                                            width: "100%"
                                                          },
                                                          children: Belt_Option.getWithDefault(validationDetail.comment, "-"),
                                                          variant: "body"
                                                        }),
                                                    item: true
                                                  }), React.createElement(Core.Grid, {
                                                    children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                                          gutterBottom: true,
                                                          style: {
                                                            fontWeight: "600",
                                                            whiteSpace: "nowrap"
                                                          },
                                                          children: React.createElement(Core.Grid, {
                                                                children: React.createElement(Core.Grid, {
                                                                      children: intl.formatMessage(approved ? Messages_Orders_Detail$DvmAdminFrontendFr.validation : Messages_Orders_Detail$DvmAdminFrontendFr.refusal) + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, Caml_option.valFromOption(match)) + (
                                                                        selectedRole !== /* Dealer */7 || !User_Types_Utils$DvmAdminFrontendFr.isAdminDealer(selectedRole) ? " - " + match$1 : ""
                                                                      ),
                                                                      item: true
                                                                    }),
                                                                container: true,
                                                                direction: "column",
                                                                item: true
                                                              }),
                                                          variant: "body"
                                                        }),
                                                    item: true
                                                  }));
                                  }
                                  return React.createElement(Core.Grid, {
                                              children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                                    style: {
                                                      fontWeight: "600"
                                                    },
                                                    children: React.createElement(Core.Grid, {
                                                          children: React.createElement(Core.Grid, {
                                                                children: intl.formatMessage(approved ? Messages_Orders_Detail$DvmAdminFrontendFr.validationWithoutInfo : Messages_Orders_Detail$DvmAdminFrontendFr.refusalWithoutInfo),
                                                                item: true
                                                              }),
                                                          container: true,
                                                          direction: "column",
                                                          item: true
                                                        }),
                                                    variant: "body"
                                                  }),
                                              item: true
                                            });
                                }));
                  })));
}

var Status = {
  make: Order_Detail_Bonus_Box_Shared$Status
};

function Order_Detail_Bonus_Box_Shared$ClickableFlash(Props) {
  var bonus = Props.bonus;
  var filteredRequest = Props.filteredRequest;
  var kind = Props.kind;
  var intl = ReactIntl.useIntl();
  return React.createElement(Core.Box, {
              children: null
            }, React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                  style: {
                    color: Theme_Colors$DvmAdminFrontendFr.mineralDarker
                  },
                  children: intl.formatMessage(Messages_Flash_Search$DvmAdminFrontendFr.flashMarketingActionID),
                  variant: "body"
                }), React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                  style: {
                    fontWeight: "600"
                  },
                  children: Belt_Option.isSome(filteredRequest) ? Belt_Option.getWithDefault(bonus.actionId, "-") : React.createElement(Core.Link, {
                          children: Belt_Option.getWithDefault(bonus.actionId, "-"),
                          color: "textPrimary",
                          style: {
                            cursor: "pointer"
                          },
                          onClick: (function (param) {
                              Belt_Option.mapWithDefault(bonus.actionId, undefined, (function (actionID) {
                                      RescriptReactRouter.push(Route_Paths$DvmAdminFrontendFr.rView + Route_Paths$DvmAdminFrontendFr.rFlash + (
                                            kind === "nonfleet" ? "/nonfleet/" : "/fleet/"
                                          ) + actionID);
                                    }));
                            })
                        }),
                  variant: "body"
                }));
}

var ClickableFlash = {
  make: Order_Detail_Bonus_Box_Shared$ClickableFlash
};

var Msg;

var StatusTypes;

var Styles;

export {
  Msg ,
  StatusTypes ,
  Styles ,
  isPSERWithEmptyStatus ,
  getAmountText ,
  Status ,
  ClickableFlash ,
}
/* react Not a pure module */
